import { Button } from "@chakra-ui/react"
import { SchoolBillingInvoice } from "@pathwright/features/src/modules/api/generated"
import { usePathwrightContext } from "@pathwright/features/src/modules/pathwright/PathwrightContext"
import { PopupButton } from "@typeform/embed-react"

type ManageBillingPlanTypeformModalProps = {
  typeformId: string
  invoice: SchoolBillingInvoice
  title?: string
  renderTrigger?: () => React.ReactNode
}

const ManageBillingPlanTypeformModal = ({
  typeformId,
  invoice,
  renderTrigger,
  title = "Upgrade or downgrade your plan"
}: ManageBillingPlanTypeformModalProps) => {
  const { me, school } = usePathwrightContext()
  const planName = invoice?.invoice_json?.plan_details?.name

  return (
    <PopupButton
      id={typeformId}
      style={{
        backgroundColor: "transparent",
        border: "none",
        padding: "0",
        margin: "0",
        cursor: "pointer"
      }}
      hidden={{
        first_name: me?.first_name || "",
        last_name: me?.last_name || "",
        email: me?.email || "",
        school_url: school?.url || "",
        current_plan: planName || ""
      }}
    >
      {renderTrigger ? renderTrigger() : <Button>{title}</Button>}
    </PopupButton>
  )
}

export default ManageBillingPlanTypeformModal
